import { render } from "./LikertSurvey.vue?vue&type=template&id=1f130273&scoped=true"
import script from "./LikertSurvey.vue?vue&type=script&lang=ts"
export * from "./LikertSurvey.vue?vue&type=script&lang=ts"

import "./LikertSurvey.vue?vue&type=style&index=0&id=1f130273&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-1f130273"

export default script